import cx from 'classnames';
import React from 'react';
import { BenefitsItem } from '../types';

type IllustrationsProps = {
    items: Array<BenefitsItem>;
    activeIdx: number;
    staticIllustration?: React.ReactElement;
};

export const Illustrations: React.FC<IllustrationsProps> = (props) => {
    const renderItems = () => {
        if (props.staticIllustration) {
            return (
                <span className="boost-benefits__illustration--item active">
                    {props.staticIllustration}
                </span>
            );
        }

        return props.items.map(({ illustration }, idx) => {
            return (
                <span
                    className={cx([
                        'boost-benefits__illustration--item',
                        { active: idx === props.activeIdx },
                    ])}
                    key={idx}
                >
                    {illustration}
                </span>
            );
        });
    };
    return <div className="boost-benefits__illustration">{renderItems()}</div>;
};
